import {Component, HostBinding, OnInit} from '@angular/core';

@Component({
  selector: 'rm-flipper',
  template: `
    <div class='rm-flipper' [ngClass]="{'flipped': flipped }">
      <div class="front tile">
        <img class="img-responsive" src="assets/images/quetz-large.png" alt="quetz">
      </div>
      <div class="back tile">
        <img class="img-responsive" src="assets/images/quetz-large-rev.png" alt="teza">
      </div>
    </div>
  `,
  styleUrls: ['flipper.component.scss']
})
export class FlipperComponent implements OnInit {

  @HostBinding('class.flipped') flipped = false;
  ngOnInit() {
    setTimeout(()=> {
      this.flip();
    }, 0);

    setInterval(()=> {
      this.flip();
    }, 10000);
  }

  flip() {
  this.flipped = !this.flipped;
}



}



// WEBPACK FOOTER //
// ./src/app/flipper/flipper.component.ts